import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintEdi_ds_get_materials_for_validationService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { project_lookup?: string, lookup_codes?: string[], upc_codes?: string[], owner_lookup?: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, PackagingLookups?: { UpcCode?: string, Packaging?: { Name?: string, ShortName?: string } }[], Project?: { LookupCode?: string, Name?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { project_lookup?: string, lookup_codes?: string[], upc_codes?: string[], owner_lookup?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, PackagingLookups?: { UpcCode?: string, Packaging?: { Name?: string, ShortName?: string } }[], Project?: { LookupCode?: string, Name?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { project_lookup?: string, lookup_codes?: string[], upc_codes?: string[], owner_lookup?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, PackagingLookups?: { UpcCode?: string, Packaging?: { Name?: string, ShortName?: string } }[], Project?: { LookupCode?: string, Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      project_lookup?: string, lookup_codes?: string[], upc_codes?: string[], owner_lookup?: string    }) {
      return false;
    }
}
